module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.goOff()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "arrow-left",
      "size": "1.5em"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600",
      "color": "#000"
    }
  }, [_vm._v("公司信息")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chakang"
  }, [_vm._v("您即将查看公司信息")]), _vm._v(" "), _c('div', {
    staticClass: "baozheng"
  }, [_vm._v("为了保证双方信息安全，请先按照提示完成安全验证")]), _vm._v(" "), _c('div', {
    staticClass: "quyanz",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("去验证")]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "yanzhengma"
  }, [_c('p', {
    staticClass: "guanbi",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "anquan",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("安全验证")])]), _vm._v(" "), _c('div', {
    staticClass: "yanzhengmade"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputCode),
      expression: "inputCode"
    }],
    staticClass: "shuruyanz",
    attrs: {
      "type": "text",
      "placeholder": "请输入下图验证码，不区分大小写"
    },
    domProps: {
      "value": (_vm.inputCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('VerifyStyle', {
    attrs: {
      "identifyCode": _vm.identifyCode
    }
  }), _vm._v(" "), _c('van-icon', {
    staticStyle: {
      "position": "absolute",
      "right": "15px",
      "margin-top": "16px"
    },
    attrs: {
      "name": "replay",
      "size": "2em"
    },
    on: {
      "click": function($event) {
        return _vm.refreshCode()
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "tijiaoanniu",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getSubmitData()
      }
    }
  }, [_vm._v("提交")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4cad3e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/naturalendowments/Companyinformation.vue
// module id = 553
// module chunks = 0